import Segment from '@/components/ui/Segment'
import { useTranslation } from 'react-i18next'
import type { PlanInterval } from '../utils/plans'

type Props = {
    value: PlanInterval
    onChange: (value: PlanInterval) => void
    className?: string
}

/** Monthly / Yearly. Yearly is the default, as the price list asks. */
const IntervalToggle = ({ value, onChange, className }: Props) => {
    const { t } = useTranslation()
    return (
        <Segment
            className={className}
            size="sm"
            value={value}
            onChange={(next) => onChange(next as PlanInterval)}
        >
            <Segment.Item value="monthly">
                {t('billing.interval.monthly')}
            </Segment.Item>
            <Segment.Item value="yearly">
                {t('billing.interval.yearly')}
            </Segment.Item>
        </Segment>
    )
}

export default IntervalToggle
